import { render, staticRenderFns } from "./ProjectReprintArchive.vue?vue&type=template&id=771219e6&scoped=true&lang=pug&"
import script from "./ProjectReprintArchive.vue?vue&type=script&lang=ts&"
export * from "./ProjectReprintArchive.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectReprintArchive.vue?vue&type=style&index=0&id=771219e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771219e6",
  null
  
)

export default component.exports